import { motion } from "framer-motion";
import { Nav } from "../components/Nav";

const PARAGRAPHS = [
  "Since 2019, Appalachian Guns exists because no one in the 2A community in this region caters to the working man and they certainly don't look twice at the younger punk looking guy who doesn't look like he has any money to spend. Their loss, that's where we shine. Being a home-based FFL/SOT we set our own hours. So we choose to be open when others aren't. When folks work 6-6 or 9-5 and clock out everything is closed. Not us. We are here. Thursday at 7pm? Saturday at 8pm? Sunday at 8am? We offer availability for all that. We don't keep a normal schedule. We don't have a \u201cstorefront\u201d that sits open 8 hours a day. You text, email, call us and we cater to you. Ever walked into a store and gotten completed ignored by 3 employees who were too busy gossiping over topics you couldn't care less about? Yeah, me too. Another reason we're here.",
  "We literally invite you into a portion of our home, so you're treated with respect and you get most of our attention. Sorry there might be a cat, dog or kid wander through that misdirects some attention.",
  "We aren't open regular hours because we work those hours just like you, we go to sports, kid pickup lines, grocery shopping and doctor's appointments. So we choose to do the evening weekend thing to better fit the needs of the regular joe.",
  "There's nothing App Guns can't find for you, we will hunt it down. There's nothing we can't help you with. We will find someone to help you if we can't. We won't settle for letting you overpay someplace else because dollars are too hard to get these days and disappear far too quickly to get taken advantage of on pricing.",
  "When you shop here, ship here, or order here you can bet those dollars are appreciated. We don't have 3 vacation homes, 7 cars or take exotic trips to show off on Facebook. Those dollars you hand us go to Happy Meals, school clothes, cleats, work boots, gas for dirt bikes, blades for the mower, diesel for the tractor, you can literally almost see the dollars in action. You may even roll up and see a dirt bike or that mower in action.",
  "As more or less a 1 man show here at Appalachian Guns, I strive to provide you with the absolute best gun shop experience you will ever have. You can ask around and I am positive, you'll hear exactly that as reviews from other customers. I have customers come from more than 5 hours away simply because of the way I treat them. I give you the attention you deserve when you show up. Come see me, let me show you what a great gun shop interaction is really like, you won't regret it.",
];

export default function StoryPage() {
  return (
    <div data-testid="story-page" className="bg-[#050505] text-white min-h-screen">
      <Nav />
      <div className="px-6 md:px-12 pt-44 md:pt-52 pb-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-violet-400 text-xs tracking-[0.35em] uppercase mb-4">Origin Story</p>
          <h1 className="font-display uppercase tracking-tighter text-5xl md:text-7xl leading-[0.95] max-w-4xl">
            Built for the <span className="text-[#C8AD7F]">working</span>{" "}
            <span className="text-outline-purple">man</span>
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mt-14 max-w-4xl"
        >
          <div className="border border-white/10 overflow-hidden">
            <img
              src="/assets/family.webp"
              alt="The family behind Appalachian Guns"
              data-testid="story-family-photo"
              className="w-full object-cover"
            />
          </div>
          <p className="text-white/40 text-xs uppercase tracking-[0.3em] mt-3" data-testid="story-family-caption">
            The family behind the counter
          </p>
        </motion.div>

        <div className="mt-16 max-w-3xl space-y-10">
          {PARAGRAPHS.map((p, i) => (
            <motion.p
              key={i}
              data-testid={`story-paragraph-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className={`text-base md:text-lg leading-relaxed border-l-2 pl-6 ${
                i % 2 === 0 ? "border-primary text-white/75" : "border-violet-400 text-white/75"
              } ${i === PARAGRAPHS.length - 1 ? "text-white font-medium" : ""}`}
            >
              {p}
            </motion.p>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-16"
        >
          <a
            href="/#book"
            data-testid="story-book-btn"
            className="inline-block bg-primary text-white px-8 py-4 uppercase tracking-widest text-sm font-semibold hover:bg-[#FF7733] transition-colors"
          >
            Book a Visit
          </a>
        </motion.div>
      </div>
    </div>
  );
}
